"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_VALUE = exports.TYPE = void 0;
const constants_1 = require("../../constants");
exports.TYPE = 'image';
exports.DEFAULT_VALUE = {
    image: constants_1.imageValue,
    overlay: null,
};
